import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ItemEditContextModel } from '../services/item.service';

@Component({
    selector: 'item-post',
    template: `
        <item-editor [itemId]="itemEditContextModel?.itemId" 
                     [sourceItemId]="itemEditContextModel?.sourceItemId"
                     [topicId]="itemEditContextModel?.topicId" 
                     (finished)="done.emit()"></item-editor>
    `
})
export class ItemPostComponent {
    @Input() itemEditContextModel :ItemEditContextModel;
    @Output() done = new EventEmitter<void>();
}